module.exports = __webpack_public_path__ + "static/media/gi.dce455a7.svg";